/** @typedef {{ url: string, tier: string, slug?: string|null }} ResolvedOrgTourHero */

/**
 * Tier E — curated travel (never local tour-cover asset).
 */
export const ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL =
  "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1920&q=88&fm=webp&auto=format&fit=max";

const UNSPLASH_HOST = /images\.unsplash\.com/i;

/** Same asset with different query params (e.g. Unsplash w= / q=) → one identity for deduping. */
export function organizedTourImageIdentityKey(url) {
  const s = String(url || "").trim();
  if (!s) return "";
  try {
    const u = new URL(s);
    return `${u.origin}${u.pathname}`.toLowerCase();
  } catch {
    const base = s.split(/[?#]/)[0];
    return base.toLowerCase();
  }
}

/**
 * Bump Unsplash CDN params toward crisp cards/hero (~2k wide, sharp webp).
 * Non-Unsplash URLs are returned unchanged.
 */
export function upgradeOrganizedTourRemoteImageUrl(url) {
  if (!url || typeof url !== "string") return "";
  const t = url.trim();
  if (!UNSPLASH_HOST.test(t)) return t;
  try {
    const u = new URL(t);
    if (!/^\/photo-|^\/\d/.test(u.pathname)) return t;
    u.searchParams.set("w", "1920");
    u.searchParams.set("q", "88");
    u.searchParams.set("fm", "webp");
    u.searchParams.set("auto", "format");
    u.searchParams.set("fit", "max");
    u.searchParams.delete("h");
    return u.toString();
  } catch {
    const sep = t.includes("?") ? "&" : "?";
    return `${t}${sep}w=1920&q=88&fm=webp&auto=format&fit=max`;
  }
}

/** Reject obvious HTML/non-image resource URLs (LDS brochure pages). Still allow ambiguous https URLs so suppliers keep working. */
export function organizedTourLooksLikeDirectImageUrl(url) {
  if (!url || typeof url !== "string") return false;
  const lower = url.trim().toLowerCase();
  if (!/^https?:\/\//i.test(lower) && !lower.startsWith("//")) return false;
  if (/\.html?(\?|#|$)/i.test(lower) || /\/resource\/?$/i.test(lower)) return false;
  if (/\.pdf(\?|#|$)/i.test(lower)) return false;
  return true;
}

/** Heuristic: obvious thumbnail / tiny CDN width — log in DEV; caller may still upgrade Unsplash. */
export function organizedTourImageUrlLooksLowRes(url) {
  if (!url || typeof url !== "string") return false;
  const u = url.toLowerCase();
  if (/thumb|thumbnail|_xs\b|_sm\b|\/small\//i.test(u)) return true;
  const m = u.match(/[?&]w=(\d+)/i);
  if (m && Number(m[1]) > 0 && Number(m[1]) < 480) return true;
  return false;
}
